import * as React from "react";
const SvgAdd = (props) => /* @__PURE__ */ React.createElement("svg", { width: "1em", height: "1em", viewBox: "0 0 18 18", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M14 8.375H9.625V4H8.375V8.375H4V9.625H8.375V14H9.625V9.625H14V8.375Z", fill: "currentColor" }));
export default SvgAdd;
